PJQ.views.invoices.Invoices = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.INVOICES, 'invoices'),
        isShowHeader: true
    },
    events: {
        'click .btn-invoice-settings': 'userSettings',
        'keyup .input-search': 'searchChanged',
        'click .search': 'search',
        'click .clear-search': 'clearFilter',
        'click .new-invoice': 'newInvoice',
        'click .export-list': 'exportList'
    },
    beforeFirstRender: function () {
        this.isSettingsFetched = false;

        this.userSettings = new PJQ.models.invoices.InvoiceUserSettings();
        this.userSettings.fetch({
            success: _.bind(function () {
                this.isSettingsFetched = true;
                this.currentView = 'invoices';
                this.render();
            }, this)
        });
    },
    renderData: function () {
        return {
            showHeader: this.options.isShowHeader,
            isAdmin: PJQ.app.session.hasPermission('invoices.isAdmin'),
            settingsFetched: this.isSettingsFetched
        };
    },
    afterRender: function () {
        if (!this.isSettingsFetched)
            return;

        let startDate = null;
        switch (this.userSettings.get('defaultDateRange')) {
            case PJQ.constants.invoices.invoiceDateRange.MONTH_TO_DATE:
                startDate = PJQ.helpers.dateHelpers.parseDateString(PJQ.helpers.dateHelpers.getCurrentYear() + '-' + PJQ.helpers.dateHelpers.getCurrentMonth() + '-01 00:00:00');
                break;
            case PJQ.constants.invoices.invoiceDateRange.YEAR_TO_DATE:
                startDate = PJQ.helpers.dateHelpers.parseDateString(PJQ.helpers.dateHelpers.getCurrentYear() + '-01-01 00:00:00');
                break;
            case PJQ.constants.invoices.invoiceDateRange.DAYS_30:
                startDate = PJQ.helpers.dateHelpers.getNewDateAddDays(new Date(), -30);
                break;
            case PJQ.constants.invoices.invoiceDateRange.DAYS_60:
                startDate = PJQ.helpers.dateHelpers.getNewDateAddDays(new Date(), -60);
                break;
            case PJQ.constants.invoices.invoiceDateRange.DAYS_90:
                startDate = PJQ.helpers.dateHelpers.getNewDateAddDays(new Date(), -90);
                break;
            case PJQ.constants.invoices.invoiceDateRange.DAYS_180:
                startDate = PJQ.helpers.dateHelpers.getNewDateAddDays(new Date(), -180);
                break;
        }

        this.startDateDatePicker = new PJQ.inputs.Datepicker({
            el: this.$('.start-date'),
            datepickerOptions: {
                defaultDate: startDate,
                format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
            },
            onChange: _.bind(function() {
                this.renderView();
            }, this)
        });

        this.endDateDatePicker = new PJQ.inputs.Datepicker({
            el: this.$('.end-date'),
            datepickerOptions: {
                defaultDate: new Date(),
                format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
            },
            onChange: _.bind(function() {
                this.renderView();
            }, this)
        });

        this.viewSelectPicker = new PJQ.inputs.Selectpicker({
            el: this.$('.invoices-view'),
            isIntChoices: false,
            isMultiple: false,
            mustSelectValue: true,
            defaultValue: this.userSettings.get('defaultView'),
            onHide: _.bind(function() {
                this.renderView();
            }, this)
        });

        this.invoiceStatusSelectPicker = new PJQ.inputs.Selectpicker({
            el: this.$('select.invoice-status'),
            isIntChoices: true,
            isMultiple: true,
            mustSelectValue: true,
            defaultValue: [PJQ.constants.invoices.invoiceStatus.DRAFT, PJQ.constants.invoices.invoiceStatus.PAYMENT_REQUESTED, PJQ.constants.invoices.invoiceStatus.PENDING, PJQ.constants.invoices.invoiceStatus.PAID, PJQ.constants.invoices.invoiceStatus.VOIDED, PJQ.constants.invoices.invoiceStatus.REFUNDED, PJQ.constants.invoices.invoiceStatus.RETURNED],
            onHide: _.bind(function() {
                this.renderView();
            }, this)
        });

        this.transactionTypeSelectPicker = new PJQ.inputs.Selectpicker({
            el: this.$('select.transaction-type'),
            isIntChoices: true,
            isMultiple: true,
            mustSelectValue: true,
            defaultValue: [PJQ.constants.invoices.transactionType.PAYMENT_PENDING, PJQ.constants.invoices.transactionType.PAYMENT,PJQ.constants.invoices.transactionType.VOID,PJQ.constants.invoices.transactionType.REFUND, PJQ.constants.invoices.transactionType.RETURN, PJQ.constants.invoices.transactionType.REFUND_PENDING ],
            onHide: _.bind(function() {
                this.renderView();
            }, this)
        });

        this.renderView();

        if (this.options.invoiceId > 0) {
            let invoice = new PJQ.models.invoices.Invoice();
            invoice.set('invoiceId', this.options.invoiceId);
            invoice.fetch({
                success: _.bind(function() {
                    new PJQ.views.invoices.InvoiceEditModal({
                        model: invoice,
                        invoicesView: this,
                        onSave: _.bind(function() {
                            this.renderView();
                        }, this),
                        onDelete: _.bind(function() {
                            this.renderView();
                        }, this)
                    });
                }, this)
            });
            this.options.invoiceId = null;
        }
    },
    renderView: function(view, options = {}) {
        this.currentView = view ? view : this.viewSelectPicker.getValue();

        if (this.currentView === PJQ.constants.invoices.view.INVOICES) {
            this.invoiceStatusSelectPicker.show();
            this.transactionTypeSelectPicker.hide();
        }
        else if (this.currentView === PJQ.constants.invoices.view.TRANSACTIONS) {
            this.invoiceStatusSelectPicker.hide();
            this.transactionTypeSelectPicker.show();
        }

        PJQ.helpers.inputHelpers.setInputError(this.$('.start-date, .end-date'), true);
        if (this.startDateDatePicker.getValue() > this.endDateDatePicker.getValue()) {
            PJQ.helpers.inputHelpers.setInputError(this.$('.start-date, .end-date'), false);
            return;
        }

        let page = null;
        if (options.stayOnPage && this.dataTable != null) {
            page = this.dataTable.dataTable.page();
        }

        if (this.dataTable) {
            this.dataTable.cleanup();
            this.dataTable.clearServerCache = true;
            this.dataTable.pageCache = [];
            this.dataTable.remove();
            this.dataTable = null;
            this.$('.invoices-data').empty();
        }

        let tableSettings = this.userSettings.getSettings(this.currentView),
            dataTableOptions = {
                el: this.$('.invoices-data'),
                language: {
                    zeroRecords: 'No Results Available'
                },
                data: null,
                view: this.currentView,
                invoicesView: this,
                settings: tableSettings,
                getPageCallback: _.bind(this.getViewData, this),
                displayStart: page != null ? page * tableSettings.rowsPerPage : null,
                deferRender: true,
                clearServerCache: true,
                showPageSelector: true,
                onTableDraw: _.bind(function (dataTable) {
                    this.$('.invoices-data').css('margin-top', -40);
                }, this)
            };

        this.dataTable = this.getDataTableInstance(dataTableOptions);
    },
    getViewData: function (pageNumber, pageSize, orderArr, callback) {
        let order = orderArr[0];
        this.data = null;

        switch(this.currentView) {
            case PJQ.constants.invoices.view.INVOICES:
                this.data = new PJQ.collections.invoices.Invoices();
                break;
            case PJQ.constants.invoices.view.TRANSACTIONS:
                this.data = new PJQ.collections.invoices.Transactions();
                break;
        }

        let dateNow = new Date(), parameters = {
            searchFor: this.$('.input-search').val(),
            startDate: PJQ.helpers.dateHelpers.getDateString(this.startDateDatePicker.getValue(), PJQ.helpers.dateHelpers.dateFormats.DATE_YMD),
            endDate: PJQ.helpers.dateHelpers.getDateString(this.endDateDatePicker.getValue(), PJQ.helpers.dateHelpers.dateFormats.DATE_YMD),
            page: pageNumber,
            pageSize: pageSize,
            orderBy: order.name,
            orderDirection: order.direction,
            timeZoneOffset: dateNow.getTimezoneOffset()
        };

        if (this.currentView === PJQ.constants.invoices.view.INVOICES) {
            parameters.invoiceStatus = this.invoiceStatusSelectPicker.getValue().join(',');
        }
        else if (this.currentView === PJQ.constants.invoices.view.TRANSACTIONS) {
            parameters.transactionType = this.transactionTypeSelectPicker.getValue().join(',');
        }

        this.data.fetch({
            data: parameters,
            success: _.bind(function () {

                if (this.currentView === PJQ.constants.invoices.view.INVOICES) {
                    this.$('.invoice-stats').removeClass('hidden');
                    this.$('.total-rows-label').text('Invoices');
                    this.$('.total-rows').text(this.data.totalRows);
                    this.$('.total-draft').text(PJQ.helpers.formatHelpers.formatCurrency(this.data.totalDraft));
                    this.$('.total-requested').text(PJQ.helpers.formatHelpers.formatCurrency(this.data.totalRequested));
                    this.$('.total-pending').text(PJQ.helpers.formatHelpers.formatCurrency(this.data.totalPaymentPending));
                    this.$('.total-paid').text(PJQ.helpers.formatHelpers.formatCurrency(this.data.totalPaid));
                    this.$('.total-voided').text(PJQ.helpers.formatHelpers.formatCurrency(this.data.totalVoided));
                    this.$('.total-refunded').text(PJQ.helpers.formatHelpers.formatCurrency(this.data.totalRefunded));
                    this.$('.total-returned').text(PJQ.helpers.formatHelpers.formatCurrency(this.data.totalReturned));
                } else if (this.currentView === PJQ.constants.invoices.view.TRANSACTIONS) {
                    this.$('.invoice-stats').addClass('hidden');
                }

                callback(this.data.models, this.data.totalRows);
                if (this.pageSelectPicker == null) {
                    // this.renderPageSelect();
                }
            }, this),
            fail: _.bind(function () {
                callback();
            }, this)
        });
    },
    getDataTableInstance: function(options) {
        let dataTable = null;

        switch (options.view) {
            case PJQ.constants.invoices.view.INVOICES:
                dataTable = new PJQ.views.invoices.InvoiceDataTable(options);
                break;
            case PJQ.constants.invoices.view.TRANSACTIONS:
                dataTable = new PJQ.views.invoices.TransactionDataTable(options);
                break;
        }
        return dataTable;
    },
    searchChanged: function (e) {
        if (e.keyCode === 13) {
            this.search();
        }
    },
    search: function () {
        this.renderView();
    },
    clearFilter: function() {
        this.$('.input-search').val('');
        this.renderView();
    },
    userSettings: function() {
        var settings = new PJQ.models.invoices.InvoiceSettings();
        settings.fetch({
            success: _.bind(function() {
                new PJQ.views.invoices.InvoiceSettingsModal({
                    invoicesView: this,
                    settings: settings,
                    onSave: _.bind(function () {
                        this.renderView();
                        PJQ.notifications.notify.successNotify({
                            message: 'Settings updated successfully'
                        });
                    }, this)
                });
            }, this)
        });
    },
    newInvoice: function() {
        new PJQ.views.invoices.InvoiceEditModal({
            invoicesView: this,
            onSave: _.bind(function() {
                this.renderView();
            }, this)
        });
    },
    deleteInvoice: function(invoice, callback) {
        new PJQ.views.modals.DeleteCancel({
            header: "Delete Invoice",
            body: "Are you sure you want to delete this invoice?",
            onDelete: _.bind(function () {
                invoice.destroy();
                if (typeof callback === 'function') {
                    callback();
                }
                this.renderView();
            }, this)
        });

    },
    exportInvoice: function (invoiceId, context) {
        PJQ.files.downloadFile(PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'invoices',
                value: invoiceId
            },
            {
                endpoint: 'export',
            }
        ]), { isAPIv2: true });
    },
    exportList: function () {
        let parameters = [
            {
                parameter: 'searchFor',
                value: this.$('.input-search').val()
            },
            {
                parameter: 'startDate',
                value: PJQ.helpers.dateHelpers.getDateString(this.startDateDatePicker.getValue(), PJQ.helpers.dateHelpers.dateFormats.DATE_YMD)
            },
            {
                parameter: 'endDate',
                value: PJQ.helpers.dateHelpers.getDateString(this.endDateDatePicker.getValue(), PJQ.helpers.dateHelpers.dateFormats.DATE_YMD)
            },
            {
                parameter: 'timeZoneOffset',
                value: new Date().getTimezoneOffset()
            }
        ];

        if (this.currentView === PJQ.constants.invoices.view.INVOICES) {
            parameters.push({
                parameter: 'invoiceStatus',
                value: this.invoiceStatusSelectPicker.getValue().join(',')
            });
        }
        else if (this.currentView === PJQ.constants.invoices.view.TRANSACTIONS) {
            parameters.push({
                parameter: 'transactionType',
                value: this.transactionTypeSelectPicker.getValue().join(',')
            });
        }
        var downloadEndpoint = [
            {
                endpoint: 'invoices'
            }
        ];

        if (this.currentView === PJQ.constants.invoices.view.TRANSACTIONS) {
            downloadEndpoint.push({
                endpoint: 'transactions'
            });
        }

        downloadEndpoint.push({
            endpoint: 'export'
        });

        PJQ.files.downloadFile(PJQ.helpers.urlHelpers.generateEndpoint(downloadEndpoint, parameters), { isAPIv2: true });
    }
});

PJQ.views.invoices.InvoiceEditModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.INVOICES, 'modal-invoice-edit'),
        minWidth: 1000,
        model: null,
        invoicesView: null,
        onSave: _.noop(),
        onDelete: _.noop()
    },
    events: {
        'click button.view-notifications': 'viewNotifications',
        'click button.view-transactions': 'viewTransactions',
        'click button.select-payor': 'selectPayor',
        'click button.clear-payor': 'clearPayor',
        'click button.invoice-save': 'onSave',
        'click button.invoice-delete': 'deleteInvoice',
        'click button.invoice-void': 'voidInvoice',
        'click button.add-line-item': 'addLineItem',
        'click button.save-line-item': 'saveLineItem',
        'click button.cancel-edit-line-item': 'cancelEditLineItem',
        'click button.edit-line-item': 'editLineItem',
        'click button.delete-line-item': 'deleteLineItem',
        'click button.invoice-export': 'exportInvoice',
        'click button.invoice-request-payment': 'requestPayment',
        'click button.invoice-manual-payment': 'manualPayment'
    },
    beforeModalCreated: function () {
        if (this.options.model)
            this.model = this.options.model;
        else {
            this.model = new PJQ.models.invoices.Invoice();
            this.model.set('invoiceDate', PJQ.helpers.dateHelpers.getDateString(new Date(), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME, false));
            this.model.set('invoiceStatusId', PJQ.constants.invoices.invoiceStatus.DRAFT);
            this.model.attributes.payor = {
                contactId: 0,
                country: 'US'
            };
            this.model.attributes.lineItems = [];
        }
    },
    /*
    beforeRender: function () {

    },

     */
    renderData: function () {
        return {
            model: this.model,
            canEdit: PJQ.app.session.hasPermission('invoices.isAdmin') && (this.model.get('invoiceStatusId') === PJQ.constants.invoices.invoiceStatus.DRAFT || this.model.get('invoiceStatusId') === PJQ.constants.invoices.invoiceStatus.PAYMENT_REQUESTED)
        }
    },
    afterRender: function () {
        let self = this;

        new PJQ.Binder(this.$el, this.model, {
            watchElements: [
                'input',
                'textarea'
            ]
        });

        new PJQ.inputs.Datepicker({
            el: this.$('.invoice-date'),
            datepickerOptions: {
                format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                defaultDate: this.model.get('invoiceDate') ? new Date(this.model.get('invoiceDate')) : new Date()
            },
            onChange: _.bind(function (newDate) {
                this.model.set('invoiceDate', newDate);
            }, this)
        });

        this.statePicker = new PJQ.inputs.Selectpicker({
            el: this.$('.payor-state'),
            noneSelectedText: 'Select State',
            defaultValue: _.size(this.model.get('payor').state) > 0 ? this.model.get('payor').state.toLowerCase() : null,
            onChange: _.bind(function (value) {
                this.model.get('payor').state = value.toUpperCase();
            }, this)
        });
        this.countryChanged();

        this.countryPicker = new PJQ.inputs.Selectpicker({
            el: this.$('.payor-country'),
            noneSelectedText: 'Select Country',
            defaultValue: _.size(this.model.get('country')) > 0 ? this.model.get('country').toLowerCase() : 'us',
            onChange: _.bind(function (value) {
                this.model.get('payor').country = value.toUpperCase();
                this.model.get('payor').zip = '';
                this.model.get('payor').state = '';
                this.countryChanged();
            }, this)
        });

        PJQ.helpers.inputHelpers.inputMaskPhone(this.$('input.payor-phone'));
        PJQ.helpers.inputHelpers.inputMaskPhone(this.$('input.payor-fax'));

        this.editLineItemRow = null;
        this.lineItemsDataTable = new PJQ.views.dataTables.DataTable({
            el: this.$('.line-items'),
            pageLength: 999999,
            isHideSearch: true,
            data: this.model.get('lineItems'),
            language: {
                zeroRecords: 'Click "Add Line Item" to add a line item'
            },
            dom: 't',
            order: [],
            columns: [
                {
                    "title": "Description",
                    "orderable": false,
                    "render": _.bind(function (data, type, row) {
                        if (this.editLineItemRow === row) {
                            return '<input type="text" class="form-control input-line-item-description " value="' + row.description + '">';
                        }
                        else {
                            return row.description;
                        }
                    }, this)
                },
                {
                    "title": "Quantity",
                    "width": '75px',
                    "className": "text-align-right",
                    "orderable": false,
                    "render": _.bind(function (data, type, row) {
                        if (this.editLineItemRow === row) {
                            return '<input type="text" class="form-control input-line-item-quantity" value="' + (row.quantity / 100).toFixed(2).toString() + '">';
                        }
                        else {
                            return (row.quantity / 100).toFixed(2).toString();
                        }
                    }, this)
                },
                {
                    "title": "Unit Price",
                    "width": '100px',
                    "className": "text-align-right",
                    "orderable": false,
                    "render": _.bind(function (data, type, row) {
                        if (this.editLineItemRow === row) {
                            return '<input type="text" class="form-control input-line-item-unit-price" value="' + (row.unitPrice / 100).toFixed(2).toString() + '">';
                        }
                        else {
                            return PJQ.helpers.formatHelpers.formatCurrency(row.unitPrice);
                        }
                    }, this)
                },
                {
                    "title": "Ext. Price",
                    "width": '100px',
                    "className": "text-align-right",
                    "orderable": false,
                    "render": _.bind(function (data, type, row) {
                        return PJQ.helpers.formatHelpers.formatCurrency(row.extPrice);
                    }, this)
                },
                {
                    "title": '',
                    "render": _.bind(function (data, type, row) {
                        let html = '';
                        if (this.model.get('invoiceStatusId') === PJQ.constants.invoices.invoiceStatus.DRAFT || this.model.get('invoiceStatusId') === PJQ.constants.invoices.invoiceStatus.PAYMENT_REQUESTED) {
                            html += '<div class="show-on-row-hover">';

                            if (PJQ.app.session.hasPermission('invoices.isAdmin') && this.editLineItemRow === row) {
                                html += '<button type="button" class="btn btn-success save-line-item ml-1" title="Save Line Item"><i class="fal fa-save"></i></button>';
                                html += '<button type="button" class="btn btn-danger cancel-edit-line-item ml-1" title="Cancel Edit"><i class="fal fa-times"></i></button>';
                            } else if (PJQ.app.session.hasPermission('invoices.isAdmin') && this.editLineItemRow !== row) {
                                html += '<button type="button" class="btn btn-info edit-line-item ml-1" title="Edit Line Item"><i class="fal fa-pencil"></i></button>';
                                html += '<button type="button" class="btn btn-danger delete-line-item ml-1" title="Delete Line Item"><i class="fal fa-trash"></i></button>';
                            }

                            html += '</div>';
                        }
                        return html;
                    }, this),
                    "orderable": false,
                    "searchable": false,
                    "width": "100px",
                    "className": "text-center",
                    "visible": true
                }
            ]
        });
        this.$('.line-items').on('draw.dt', _.bind(function () {
            PJQ.helpers.inputHelpers.inputMaskDecimal(this.$('.input-line-item-quantity'), 2);
            PJQ.helpers.inputHelpers.inputMaskCurrency(this.$('.input-line-item-unit-price'), 2);

            if (this.$('.input-line-item-description').length > 0)
                this.$('.input-line-item-description').focus();

        }, this));


        this.recalculateTotal();
        this.$('.invoice-number').focus();
    },
    addLineItem: function() {
        this.editLineItemRow = {
            invoiceLineItemId: 0,
            description: '',
            quantity: 100,
            unitPrice: 0,
            isNew: true,
            isDeleted: false
        };
        this.lineItemsDataTable.addRow(this.editLineItemRow);
    },
    saveLineItem: function(e) {
        this.$('.invoice-save').prop('disabled', false);
        let isValid = true;
        PJQ.helpers.inputHelpers.setInputError(this.$('.input-line-item-description, .input-line-item-quantity, .input-line-item-unit-price'), true);
        if (!this.$('.input-line-item-description').val()) {
            PJQ.helpers.inputHelpers.setInputError(this.$('.input-line-item-description'), false);
            isValid = false;
        }

        let quantity = parseInt(parseFloat(this.$('.input-line-item-quantity').val()) * 100);
        if (quantity <= 0) {
            PJQ.helpers.inputHelpers.setInputError(this.$('.input-line-item-quantity'), false);
            isValid = false;
        }

        let unitPrice = parseInt(parseFloat(this.$('.input-line-item-unit-price').val()) * 100);
        if (unitPrice < 0) {
            PJQ.helpers.inputHelpers.setInputError(this.$('.input-line-item-unit-price'), false);
            isValid = false;
        }

        if (!isValid)
            return;

        this.editLineItemRow.description = this.$('.input-line-item-description').val();
        this.editLineItemRow.quantity = quantity;
        this.editLineItemRow.unitPrice = unitPrice;
        this.editLineItemRow.extPrice = (quantity / 100) * unitPrice;

        if (this.editLineItemRow.isNew) {
            this.editLineItemRow.isNew = false;
            this.model.attributes.lineItems.push(this.editLineItemRow);
        }

        this.editLineItemRow = null;
        this.lineItemsDataTable.refresh();
        this.recalculateTotal();
    },
    cancelEditLineItem: function(e) {
        let row = this.lineItemsDataTable.getRow($(e.currentTarget).closest('tr')[0]);
        this.$('.invoice-save').prop('disabled', false);

        if (row.data().isNew) {
            this.model.attributes.lineItems = _.filter(this.model.attributes.lineItems, function(lineItem) {
                return !lineItem.isNew;
            });
            this.lineItemsDataTable.removeRow(row);
        }

        this.editLineItemRow = null;
        this.lineItemsDataTable.refresh();
    },
    editLineItem: function(e) {
        this.$('.invoice-save').prop('disabled', true);
        this.editLineItemRow = this.lineItemsDataTable.getRow($(e.currentTarget).closest('tr')[0]).data();
        this.lineItemsDataTable.refresh();
    },
    deleteLineItem: function(e) {
        let row = this.lineItemsDataTable.getRow($(e.currentTarget).closest('tr')[0]);
        row.data().isDeleted = true;
        this.lineItemsDataTable.removeRow(row);
        this.$('.invoice-save').prop('disabled', false);
        this.recalculateTotal();
    },
    recalculateTotal: function() {
        let total = 0;
        _.each(this.model.get('lineItems'), function(lineItem) {
            if (!lineItem.isDeleted)
                total += ((lineItem.quantity/100) * lineItem.unitPrice);
        });

        this.model.set('total', total);

        this.$('.invoice-total').html(PJQ.helpers.formatHelpers.formatCurrency(total));

        return total;
    },
    countryChanged: function() {
        let country = this.model.get('payor').country && this.model.get('payor').country.length > 0 ? this.model.get('payor').country.toLowerCase() : 'us',
            options = '<option value="">Select Value</option>';
        _.each(PJQ.constants.states[country], function (state) {
            options += '<option value="' + state.abbreviation.toLowerCase() + '">' + state.name + '</option>';
        });
        this.statePicker.$el.html(options);
        this.statePicker.refresh();
        if (this.model.get('payor').state)
            this.statePicker.setValue(this.model.get('payor').state.toLowerCase());

        PJQ.helpers.inputHelpers.inputMaskZip(this.$('.payor-zip'), country);
    },
    onSave: function() {
        let callback = _.bind(function() {
            if (typeof this.options.onSave === 'function')
                this.options.onSave();

            this.removeModal();
        }, this);

        this.save(callback);
    },
    validateForm: function() {
        let isValid = true;

        PJQ.helpers.inputHelpers.setInputError(this.$('.invoice-number, .invoice-date, .payor-companyname, .payor-email'), true);
        if (!this.model.get('invoiceNumber')) {
            PJQ.helpers.inputHelpers.setInputError(this.$('.invoice-number'), false);
            isValid = false;
        }
        if (!this.model.get('invoiceDate')) {
            PJQ.helpers.inputHelpers.setInputError(this.$('.invoice-date'), false);
            isValid = false;
        }

        if (!this.$('.payor-companyname').val()) {
            PJQ.helpers.inputHelpers.setInputError(this.$('.payor-companyname'), false);
            isValid = false;
        }

        if (!this.$('.payor-email').val() || !PJQ.helpers.validators.validateEmail(this.$('.payor-email').val()).success) {
            PJQ.helpers.inputHelpers.setInputError(this.$('.payor-email'), false);
            isValid = false;
        }

        return isValid;
    },
    save: function(callback) {
        // TODO: validation / duplicate invoice # check
        if (!this.validateForm())
            return;

        this.model.get('payor').companyName = this.$('.payor-companyname').val();
        this.model.get('payor').contactName = this.$('.payor-contactname').val();
        this.model.get('payor').address1 = this.$('.payor-address1').val();
        this.model.get('payor').address2 = this.$('.payor-address2').val();
        this.model.get('payor').city = this.$('.payor-city').val();
        this.model.get('payor').zip = this.$('.payor-zip').val();
        this.model.get('payor').phone = this.$('.payor-phone').val();
        this.model.get('payor').phoneExtension = this.$('.payor-phone-ext').val();
        this.model.get('payor').fax = this.$('.payor-fax').val();
        this.model.get('payor').email = this.$('.payor-email').val();

        if (!isValid)
            return;

        this.model.save(null, {
            success: _.bind(function () {
                PJQ.notifications.notify.successNotify({
                    message: 'Invoice saved successfully'
                });
                callback();
            }, this),
            error: _.bind(function(data) {
                // TODO: show error message if it was duplicate invoice #
                debugger;
            }, this)
        });
    },
    delete: function() {
        this.options.onDelete();
    },
    selectPayor: function() {
        new PJQ.views.contacts.SelectContactsModal({
            context: PJQ.constants.contacts.contexts.CONTACTS,
            isSingleChoice: true,
            defaultValue: this.model.get('payor').contactId,
            onSave: _.bind(function (data) {
                this.model.get('payor').contactId = data.get('contactId');
                this.model.get('payor').companyName = data.get('companyName');
                this.model.get('payor').contactName = data.get('contactName');
                this.model.get('payor').address1 = data.get('address1');
                this.model.get('payor').address2 = data.get('address2');
                this.model.get('payor').city = data.get('city');
                this.model.get('payor').state = data.get('state');
                this.model.get('payor').zip = data.get('zip');
                this.model.get('payor').country = data.get('country');
                this.model.get('payor').phone = data.get('phone');
                this.model.get('payor').phoneExtension = data.get('phoneExtension');
                this.model.get('payor').fax = data.get('fax');
                this.model.get('payor').email = data.get('email');

                this.$('.payor-companyname').val(data.get('companyName'));
                this.$('.payor-contactname').val(data.get('contactName'));
                this.$('.payor-address1').val(data.get('address1'));
                this.$('.payor-address2').val(data.get('address2'));
                this.$('.payor-city').val(data.get('city'));
                this.countryPicker.setValue('us'); // TODO: contact picker does not expose country
                this.countryChanged();
                this.statePicker.setValue(data.get('state').toLowerCase());
                this.$('.payor-zip').val(data.get('zip'));
                this.$('.payor-phone').val(data.get('phone'));
                this.$('.payor-phone-ext').val(data.get('phoneExtension'));
                this.$('.payor-fax').val(data.get('fax'));
                this.$('.payor-email').val(data.get('email'));

                this.$('.payor-companyname').focus();
            }, this)
        });
    },
    clearPayor: function() {
        this.model.get('payor').contactId = 0;
        this.model.get('payor').companyName = '';
        this.model.get('payor').contactName = '';
        this.model.get('payor').address1 = '';
        this.model.get('payor').address2 = '';
        this.model.get('payor').city = '';
        this.model.get('payor').state = '';
        this.model.get('payor').zip = '';
        this.model.get('payor').country = 'US';
        this.model.get('payor').phone = '';
        this.model.get('payor').phoneExtension = '';
        this.model.get('payor').fax = '';
        this.model.get('payor').email = '';

        this.$('.payor-companyname, .payor-contactname, .payor-address1, .payor-address2, .payor-city, .payor-zip, .payor-phone, .payor-phone-ext, .payor-fax, .payor-email').val('');
        this.countryPicker.setValue('us');
        this.countryChanged();

        this.$('.payor-companyname').focus();
    },
    viewNotifications: function() {
        new PJQ.views.invoices.ViewNotificationsModal({
            invoiceId: this.model.get('invoiceId')
        });
    },
    viewTransactions: function() {
        new PJQ.views.invoices.ViewTransactionsModal({
            invoiceId: this.model.get('invoiceId')
        });
    },
    deleteInvoice: function() {
        this.options.invoicesView.deleteInvoice(this.model, _.bind(function() { this.removeModal(); }, this));
    },
    voidInvoice: function() {
        new PJQ.views.modals.YesNo({
            header: "Void/Refund Invoice",
            body: "Are you sure you want to void/refund this invoice?",
            onYes: _.bind(function () {

                new PJQ.ajax.Request({
                    endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                        {
                            endpoint: 'invoices',
                            value: this.model.get('invoiceId')
                        },
                        {
                            endpoint: 'void'
                        }
                    ]),
                    isAPIv2: true
                }).post().done(_.bind(function (data) {
                    PJQ.notifications.notify.successNotify({
                        message: 'Invoice voided successfully'
                    });
                    this.options.invoicesView.renderView();
                    this.removeModal();
                }, this)).fail(function(data) {
                    PJQ.notifications.notify.errorNotify({
                        message: 'Unable to void this invoice'
                    });
                });

            }, this)
        });

    },
    exportInvoice: function() {
        let callback = _.bind(function () {
            if (typeof this.options.onSave === 'function')
                this.options.onSave();

            this.options.invoicesView.exportInvoice(this.model.get('invoiceId'));
        }, this);

        if (this.model.get('invoiceStatusId') === PJQ.constants.invoices.invoiceStatus.DRAFT || this.model.get('invoiceStatusId') === PJQ.constants.invoices.invoiceStatus.PAYMENT_REQUESTED)
            this.save(callback);
        else
            this.options.invoicesView.exportInvoice(this.model.get('invoiceId'));
    },
    requestPayment: function() {

        if (!this.validateForm())
            return;

        if (this.recalculateTotal() === 0) {
            new PJQ.views.BaseModal({
                header: "Amount Due Error",
                body: "Please add one or more line items before requesting payment."
            });
            return;
        }

        let callback = _.bind(function () {
            new PJQ.ajax.Request({
                endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: 'invoices',
                        value: this.model.get('invoiceId')
                    },
                    {
                        endpoint: 'requestpayment'
                    }
                ]),
                isAPIv2: true
            }).post().done(_.bind(function (response) {
                if (typeof this.options.onSave === 'function')
                    this.options.onSave();

                PJQ.notifications.notify.successNotify({
                    message: 'Request for Payment has been sent'
                });
                this.removeModal();
            }, this));
        }, this);

        if (this.model.get('invoiceStatusId') === PJQ.constants.invoices.invoiceStatus.DRAFT || this.model.get('invoiceStatusId') === PJQ.constants.invoices.invoiceStatus.PAYMENT_REQUESTED || this.model.get('invoiceStatusId') === PJQ.constants.invoices.invoiceStatus.RETURNED)
            this.save(callback);
    },
    manualPayment: function() {
        if (!this.validateForm())
            return;

        if (_.size(this.model.get('lineItems')) === 0) {
            new PJQ.views.BaseModal({
                header: "Line Item Error",
                body: "Please add one or more line items before marking paid."
            });
            return;
        }

        new PJQ.views.invoices.ManualInvoicePaymentModal({
            onPay: _.bind(function(data) {
                let callback = _.bind(function() {
                    new PJQ.ajax.Request({
                        endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                            {
                                endpoint: 'invoices',
                                value: this.model.get('invoiceId')
                            },
                            {
                                endpoint: 'manualpay'
                            }
                        ], [
                            {
                                parameter: 'paymentReference',
                                value: data
                            }
                        ]),
                        isAPIv2: true
                    }).post().done(_.bind(function (response) {
                        if (typeof this.options.onSave === 'function')
                            this.options.onSave();

                        PJQ.notifications.notify.successNotify({
                            message: 'Invoice has been marked as paid'
                        });
                        this.removeModal();
                    }, this));

                }, this);

                this.save(callback);
            }, this)
        });
    }
});

PJQ.views.invoices.ManualInvoicePaymentModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.INVOICES, 'modal-invoice-payment-manual'),
        onPay: _.noop()
    },
    events: {
        'click .payment-save': 'savePayment'
    },
    savePayment: function() {
        if (typeof this.options.onPay === 'function')
            this.options.onPay(this.$('.payment-reference').val().trim());

        this.removeModal();
    }
});

PJQ.views.invoices.InvoicePayor = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.INVOICES, 'invoice-payor')
    },
    events: {
        'click .make-payment': 'makePayment',
        'click .export': 'exportInvoice'
    },
    renderData: function () {
        return {
            invoice: this.options.invoice
        }
    },
    makePayment: function() {
        let integrationSettings = new PJQ.models.invoices.InvoiceIntegrationSettings(null, {
            invoiceId: this.options.invoice.get('invoiceId'),
            context: this.options.invoice.get('context')
        });
        integrationSettings.fetch({
            success: _.bind(function (data) {
                new PJQ.views.invoices.InvoicePaymentModal({
                    invoice: this.options.invoice,
                    integrationSettings: integrationSettings,
                    onPay: _.bind(function() {
                        this.$('.make-payment').prop('disabled', true);
                        new PJQ.views.BaseModal({
                            header: "Payment Successful",
                            body: "Your payment has been submitted.  You will receive an email with an attached invoice showing that it is Paid when the payment has processed completely."
                        });
                    }, this)
                });
            }, this)
        });

    },
    exportInvoice: function () {
        PJQ.files.downloadFile(PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'invoices',
                value: this.options.invoice.get('invoiceId')
            },
            {
                endpoint: 'export',
            }
        ], [
            {
                parameter: 'context',
                value: this.options.invoice.get('context')
            }
        ]), { isAPIv2: true });
    }
});

PJQ.views.invoices.InvoicePaymentTermsModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.INVOICES, 'modal-invoice-terms'),
        width: '600px'
    },
    events: {
    },
    afterRender: function() {
        this.$('.terms').html(this.options.terms);
    }
});

PJQ.views.invoices.InvoicePaymentModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.INVOICES, 'modal-invoice-payment'),
        width: '600px',
        onPay: _.noop()
    },
    events: {
        'click button.pay': 'pay',
        'keyup .cardholder-name': 'validateKeyUp',
        'keyup .card-number': 'validateKeyUp',
        'keyup .cvv': 'validateKeyUp',
        'keyup .billing-zip': 'validateKeyUp',
        'keyup .account-holder': 'validateKeyUp',
        'keyup .routing-number': 'validateKeyUp',
        'keyup .account-number': 'validateKeyUp',
        'change .agree': 'validateKeyUp',
        'click .terms': 'viewTerms'
    },
    renderData: function () {
        return {
            invoice: this.options.invoice,
            today: new Date()
        }
    },
    afterRender: function() {

        this.paymentTypeSelectPicker = new PJQ.inputs.Selectpicker({
            el: this.$('select.payment-type'),
            isIntChoices: true,
            isMultiple: false,
            mustSelectValue: true,
            defaultValue: this.options.integrationSettings.isCreditCard() ? PJQ.constants.invoices.paymentType.CREDIT_CARD_PAYSIMPLE : PJQ.constants.invoices.paymentType.ACH_PAYSIMPLE,
            onHide: _.bind(function() {
                if (this.paymentTypeSelectPicker.getValue() === PJQ.constants.invoices.paymentType.CREDIT_CARD_PAYSIMPLE) {
                    this.$('.credit-card').removeClass('hidden');
                    this.$('.check').addClass('hidden');
                }
                else if (this.paymentTypeSelectPicker.getValue() === PJQ.constants.invoices.paymentType.ACH_PAYSIMPLE) {
                    this.$('.credit-card').addClass('hidden');
                    this.$('.check').removeClass('hidden');
                }
            }, this)
        });

        if (!this.options.integrationSettings.isCreditCard()) {
            this.$('.credit-card').addClass('hidden');
            this.$('.check').removeClass('hidden');
            this.$('.payment-types').addClass('hidden');
        }
        else if (!this.options.integrationSettings.isACH()) {
            this.$('.payment-types').addClass('hidden');
        }

        this.expirationMonthSelectPicker = new PJQ.inputs.Selectpicker({
            el: this.$('select.exp-month'),
            isIntChoices: false,
            isMultiple: false,
            mustSelectValue: true,
            defaultValue: '01'
        });

        let today = new Date();
        this.expirationYearSelectPicker = new PJQ.inputs.Selectpicker({
            el: this.$('select.exp-year'),
            isIntChoices: false,
            isMultiple: false,
            mustSelectValue: true,
            defaultValue: today.getFullYear().toString()
        });

        this.$('.card-number').inputmask('9999999999999999999', {
            placeholder: ''
        });

        this.$('.cvv').inputmask('9999', {
            placeholder: ''
        });

        PJQ.helpers.inputHelpers.inputMaskZip(this.$('.billing-zip'), 'US');

        this.checkingAccountTypeSelectPicker = new PJQ.inputs.Selectpicker({
            el: this.$('select.checking-account-type'),
            isIntChoices: false,
            isMultiple: false,
            mustSelectValue: true,
            defaultValue: PJQ.constants.invoices.checkingAccountType.CHECKING
        });

        this.$('.routing-number').inputmask('999999999', {
            placeholder: ''
        });

        this.$('.account-number').inputmask('99999999999999999', {
            placeholder: ''
        });
    },
    validateKeyUp: function() {
        return this.validate();
    },
    validate: function(showErrors = false) {
        let isValid = true;

        PJQ.helpers.inputHelpers.setInputError(this.$('.agree'), true);
        if (!this.$('.agree').prop('checked')) {
            if (showErrors)
                PJQ.helpers.inputHelpers.setInputError(this.$('.agree'), false);

            isValid = false;
        }

        if (this.paymentTypeSelectPicker.getValue() === PJQ.constants.invoices.paymentType.CREDIT_CARD_PAYSIMPLE) {
            PJQ.helpers.inputHelpers.setInputError(this.$('.cardholder-name'), true);
            if (!_.size(this.$('.cardholder-name').val().trim()))  {
                if (showErrors)
                    PJQ.helpers.inputHelpers.setInputError(this.$('.cardholder-name'), false);
                isValid = false;
            }

            PJQ.helpers.inputHelpers.setInputError(this.$('.card-number'), true);
            if (_.size(this.$('.card-number').val().trim()) < 16)  {
                if (showErrors)
                    PJQ.helpers.inputHelpers.setInputError(this.$('.card-number'), false);
                isValid = false;
            }

            PJQ.helpers.inputHelpers.setInputError(this.$('.cvv'), true);
            if (_.size(this.$('.cvv').val().trim()) < 3)  {
                if (showErrors)
                    PJQ.helpers.inputHelpers.setInputError(this.$('.cvv'), false);
                isValid = false;
            }

            PJQ.helpers.inputHelpers.setInputError(this.$('.billing-zip'), true);
            if (!PJQ.helpers.validators.validateZip(this.$('.billing-zip').val())) {
                if (showErrors)
                    PJQ.helpers.inputHelpers.setInputError(this.$('.billing-zip'), false);
                isValid = false;
            }
        }
        else if (this.paymentTypeSelectPicker.getValue() === PJQ.constants.invoices.paymentType.ACH_PAYSIMPLE) {
            PJQ.helpers.inputHelpers.setInputError(this.$('.account-holder'), true);
            if (!_.size(this.$('.account-holder').val().trim()))  {
                if (showErrors)
                    PJQ.helpers.inputHelpers.setInputError(this.$('.account-holder'), false);
                isValid = false;
            }

            PJQ.helpers.inputHelpers.setInputError(this.$('.routing-number'), true);
            if (_.size(this.$('.routing-number').val().trim()) < 9)  {
                if (showErrors)
                    PJQ.helpers.inputHelpers.setInputError(this.$('.routing-number'), false);
                isValid = false;
            }

            PJQ.helpers.inputHelpers.setInputError(this.$('.account-number'), true);
            if (_.size(this.$('.account-number').val().trim()) < 14)  {
                if (showErrors)
                    PJQ.helpers.inputHelpers.setInputError(this.$('.account-number'), false);
                isValid = false;
            }
        }

        this.$('.pay').prop('disabled', !isValid);

        return isValid;
    },
    pay: function() {
        if (!this.validate(true))
            return;

        this.$('.pay').prop('disabled', true);

        let data = {
            context: this.options.invoice.get('context')
        };

        if (this.paymentTypeSelectPicker.getValue() === PJQ.constants.invoices.paymentType.CREDIT_CARD_PAYSIMPLE) {
            data.card = {
                cardholderName: this.$('.cardholder-name').val().trim(),
                cardNumber: this.$('.card-number').val().trim(),
                expirationMonth: this.expirationMonthSelectPicker.getValue(),
                expirationYear: this.expirationYearSelectPicker.getValue(),
                cVV: this.$('.cvv').val().trim(),
                billingZip: this.$('.billing-zip').val()
            };
        } else if (this.paymentTypeSelectPicker.getValue() === PJQ.constants.invoices.paymentType.ACH_PAYSIMPLE) {
            data.bankAccount = {
                accountType: this.checkingAccountTypeSelectPicker.getValue(),
                accountHolder: this.$('.account-holder').val().trim(),
                routingNumber: this.$('.routing-number').val().trim(),
                accountNumber: this.$('.account-number').val().trim()
            };
        }

        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'invoices',
                    value: this.options.invoice.get('invoiceId')
                },
                {
                    endpoint: 'pay'
                }
            ]),
            isAPIv2: true,
            data: data
        }).post().done(_.bind(function (data) {
            if (typeof this.options.onPay === 'function') {
                this.options.onPay();
            }
            this.removeModal();
        }, this)).fail(_.bind(function(data) {
            this.$('.pay').prop('disabled', true);
            new PJQ.views.BaseModal({
                header: "Payment Error",
                body: "Your payment could not be processed:<br />" + (data.responseText ? data.responseText : 'Unhandled Error') + '<br /><br />' + 'Call 877-219-9777 if you need assistance with your payment.'
            });
        }, this));
    },
    viewTerms: function() {
        new PJQ.views.invoices.InvoicePaymentTermsModal({
            terms: this.options.integrationSettings.getTerms()
        });
    }
});

PJQ.views.invoices.InvoiceSettingsModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.INVOICES, 'modal-invoice-settings'),
        minWidth: '1000px',
    },
    events: {
        'change .select-column': 'columnSelected',
        'click .btn-edit-company-default': 'editCompanySettings',
        'click .payment-terms-override': 'paymentTermsOverride',
        'click .payment-terms-revert': 'paymentTermsRevert',
        'click .payment-processing-terms-override': 'paymentProcessingTermsOverride',
        'click .payment-processing-terms-revert': 'paymentProcessingTermsRevert',
        'click button.settings-save': 'onSave'
    },
    beforeModalCreated: function () {
        this.userSettings = this.options.invoicesView.userSettings;
    },
    beforeRender: function () {
        // copy userSettings for our UI; we only update global userSettings object on save.
        this.options.userSettings = [];
        this.options.defaultView = this.userSettings.get('defaultView');
        this.options.defaultDateRange = this.userSettings.get('defaultDateRange');
        _.each(this.userSettings.attributes.viewSettings, _.bind(function (setting) {

            let columns = this.options.invoicesView.getDataTableInstance({
                    view: setting.view,
                    settings: this.userSettings.getSettings(setting.view)
                }).getColumns(true),
                selectedColumns = (_.size(setting.columns) > 0) ? setting.columns : setting.columnsDefault;
            _.each(columns, _.bind(function (column) {
                column.visible = selectedColumns.indexOf(column.columnData) !== -1
            }, this));

            this.options.userSettings.push({
                view: setting.view,
                rowsPerPage: setting.rowsPerPage,
                columns: columns
            });
        }, this));
    },
    renderData: function () {
        return {
            userSettings: this.userSettings,
            settings: this.options.settings,
            canEdit: PJQ.app.session.hasPermission('invoices.isAdmin')
        }
    },
    afterRender: function () {

        new PJQ.inputs.Selectpicker({
            el: this.$('select.select-view-default'),
            defaultValue: this.options.defaultView,
            onChange: _.bind(function (value) {
                this.options.defaultView = value;
            }, this)

        });

        new PJQ.inputs.Selectpicker({
            el: this.$('select.select-date-range-default'),
            defaultValue: this.options.defaultDateRange,
            onChange: _.bind(function (value) {
                this.options.defaultDateRange = value;
            }, this)

        });

        new PJQ.inputs.Selectpicker({
            el: this.$('select.select-view'),
            defaultValue: this.options.invoicesView.dataTable.options.view,
            onChange: _.bind(function (value) {
                this.selectView(value);
            }, this)
        });

        this.rowsPerPage = new PJQ.inputs.Selectpicker({
            el: this.$('select.rows-per-page'),
            isIntChoices: true,
            onChange: _.bind(function (value) {
                this.currentView.rowsPerPage = value;
            }, this)

        });
        this.selectView(this.options.invoicesView.dataTable.options.view);

        this.statePicker = new PJQ.inputs.Selectpicker({
            el: this.$('.payee-state'),
            noneSelectedText: 'Select State',
            defaultValue: _.size(this.options.settings.get('customSettings').payee.state) > 0 ? this.options.settings.get('customSettings').payee.state.toLowerCase() : null,
            onChange: _.bind(function (value) {
                this.options.settings.get('customSettings').payee.state = value.toUpperCase();
            }, this)
        });
        this.countryChanged();

        this.countryPicker = new PJQ.inputs.Selectpicker({
            el: this.$('.payee-country'),
            noneSelectedText: 'Select Country',
            defaultValue: _.size(this.options.settings.get('customSettings').payee.country) > 0 ? this.options.settings.get('customSettings').payee.country.toLowerCase() : 'us',
            onChange: _.bind(function (value) {
                this.options.settings.get('customSettings').payee.country = value.toUpperCase();
                this.options.settings.get('customSettings').payee.zip = '';
                this.options.settings.get('customSettings').payee.state = '';
                this.countryChanged();
            }, this)
        });

        PJQ.helpers.inputHelpers.inputMaskPhone(this.$('input.payee-phone'));
        PJQ.helpers.inputHelpers.inputMaskPhone(this.$('input.payee-fax'));

        if (_.size(this.options.settings.get('customSettings').paymentTerms) > 0) {
            this.$('.payment-terms').val(this.options.settings.get('customSettings').paymentTerms).prop('disabled', false);
            this.$('.payment-terms-revert').removeClass('hidden');
            this.$('.payment-terms-override').addClass('hidden');
        }
        else {
            this.$('.payment-terms').val(this.options.settings.get('defaultSettings').paymentTerms).prop('disabled', true);
            this.$('.payment-terms-revert').addClass('hidden');
            this.$('.payment-terms-override').removeClass('hidden');
        }

        if (_.size(this.options.settings.get('customSettings').paymentProcessingTerms) > 0) {
            this.$('.payment-processing-terms').val(this.options.settings.get('customSettings').paymentProcessingTerms).prop('disabled', false);
            this.$('.payment-processing-terms-revert').removeClass('hidden');
            this.$('.payment-processing-terms-override').addClass('hidden');
        }
        else {
            this.$('.payment-processing-terms').val(this.options.settings.get('defaultSettings').paymentProcessingTerms).prop('disabled', true);
            this.$('.payment-processing-terms-revert').addClass('hidden');
            this.$('.payment-processing-terms-override').removeClass('hidden');
        }

    },
    editCompanySettings: function () {
        this.userSettings = new PJQ.models.invoices.InvoiceUserSettings(null, {
            forCompany: true
        });
        this.userSettings.fetch({
            success: _.bind(function () {
                this.render();
            }, this)
        });
    },
    selectView: function (view) {
        this.currentView = _.find(this.options.userSettings, _.bind(function (setting) {
            return setting.view === view;
        }, this));

        this.rowsPerPage.setValue(this.currentView.rowsPerPage);

        if (this.dataTable) {
            this.dataTable.undelegateEvents();
            $(this.dataTable.el).empty();
        }

        this.dataTable = new PJQ.views.dataTables.DataTable({
            el: this.$('div.select-columns-datatable'),
            data: this.currentView.columns,
            isHideSearch: true,
            pageLength: 6,
            order: [],
            columns: [
                {"data": "title", "title": "Column", "orderable": false},
                {
                    "data": "visible",
                    "title": "Show",
                    "orderable": false,
                    "searchable": false,
                    "render": _.bind(function (data) {
                        return ('<div class="text-align-center"><div class="pretty p-default p-smooth fs-18 m-0"><input type="checkbox"' + (data ? ' checked ' : '') + 'class="select-column"/><div class="state p-primary"><label class="wd-0">&nbsp;</label></div></div></div>');
                    }, this),
                    "width": '10%'
                }
            ],
            dom: '<"top"<"clear">>rt<"bottom"p<"clear">>'
        });
    },
    columnSelected: function (sender) {
        this.dataTable.dataTable.row($(sender.currentTarget).closest('tr')).data().visible = $(sender.currentTarget).prop('checked');
    },
    onSave: function () {
        let isValid = true;

        PJQ.helpers.inputHelpers.setInputError(this.$('.payee-companyname, .payee-contactname, .payee-address1, .payee-city, .payee-zip, .payee-country, .payee-phone, .payee-email, .payment-terms, .payment-processing-terms'), true);
        PJQ.helpers.inputHelpers.setInputError(this.$('.payee-state'), true);
        if (!this.$('.payee-companyname').val()) {
            PJQ.helpers.inputHelpers.setInputError(this.$('.payee-companyname'), false);
            isValid = false;
        }
        if (!this.$('.payee-contactname').val()) {
            PJQ.helpers.inputHelpers.setInputError(this.$('.payee-contactname'), false);
            isValid = false;
        }
        if (!this.$('.payee-address1').val()) {
            PJQ.helpers.inputHelpers.setInputError(this.$('.payee-address1'), false);
            isValid = false;
        }
        if (!this.$('.payee-city').val()) {
            PJQ.helpers.inputHelpers.setInputError(this.$('.payee-city'), false);
            isValid = false;
        }
        if (!this.statePicker.getValue()) {
            PJQ.helpers.inputHelpers.setInputError(this.$('.payee-state'), false);
            isValid = false;
        }
        if (!this.$('.payee-zip').val()) {
            PJQ.helpers.inputHelpers.setInputError(this.$('.payee-zip'), false);
            isValid = false;
        }
        if (!this.countryPicker.getValue()) {
            PJQ.helpers.inputHelpers.setInputError(this.$('.payee-country'), false);
            isValid = false;
        }
        if (!this.$('.payee-phone').val()) {
            PJQ.helpers.inputHelpers.setInputError(this.$('.payee-phone'), false);
            isValid = false;
        }
        if (!this.$('.payee-email').val() || !PJQ.helpers.validators.validateEmail(this.$('.payee-email').val()).success) {
            PJQ.helpers.inputHelpers.setInputError(this.$('.payee-email'), false);
            isValid = false;
        }

        if (!this.$('.payment-terms').prop('disabled') && _.size(this.$('.payment-terms').val().trim()) === 0) {
            PJQ.helpers.inputHelpers.setInputError(this.$('.payment-terms'), false);
            isValid = false;
        }

        if (!this.$('.payment-processing-terms').prop('disabled') && _.size(this.$('.payment-processing-terms').val().trim()) === 0) {
            PJQ.helpers.inputHelpers.setInputError(this.$('.payment-processing-terms'), false);
            isValid = false;
        }

        if (!isValid)
            return;

        this.options.settings.get('customSettings').payee.companyName = this.$('.payee-companyname').val().trim();
        this.options.settings.get('customSettings').payee.contactName = this.$('.payee-contactname').val().trim();
        this.options.settings.get('customSettings').payee.address1 = this.$('.payee-address1').val().trim();
        this.options.settings.get('customSettings').payee.address2 = this.$('.payee-address2').val().trim();
        this.options.settings.get('customSettings').payee.city = this.$('.payee-city').val().trim();
        this.options.settings.get('customSettings').payee.zip = this.$('.payee-zip').val().trim();
        this.options.settings.get('customSettings').payee.phone = PJQ.helpers.formatHelpers.numbersOnly(this.$('.payee-phone').val().trim());
        this.options.settings.get('customSettings').payee.phoneExtension = this.$('.payee-phone-ext').val().trim();
        this.options.settings.get('customSettings').payee.fax = PJQ.helpers.formatHelpers.numbersOnly(this.$('.payee-fax').val().trim());
        this.options.settings.get('customSettings').payee.email = this.$('.payee-email').val().trim();
        this.options.settings.get('customSettings').paymentTerms = this.$('.payment-terms').prop('disabled') ? '' : this.$('.payment-terms').val().trim();
        this.options.settings.get('customSettings').paymentProcessingTerms = this.$('.payment-processing-terms').prop('disabled') ? '' : this.$('.payment-processing-terms').val().trim();

        let fnOnSave = _.bind(function () {
                if (typeof this.options.onSave === 'function')
                    this.options.onSave();
                this.removeModal();
            }, this);

        this.userSettings.set('defaultView', this.options.defaultView);
        this.userSettings.set('defaultDateRange', this.options.defaultDateRange);

        _.each(this.options.userSettings, _.bind(function (settingTemp) {
            _.each(this.userSettings.get('viewSettings'), _.bind(function (setting) {
                if (settingTemp.view === setting.view) {
                    setting.rowsPerPage = settingTemp.rowsPerPage;

                    let columns = _.size(setting.columns) > 0 ? setting.columns.slice() : setting.columnsDefault.slice();

                    // update columns
                    _.each(settingTemp.columns, _.bind(function (column) {
                        if (column.visible) {
                            if (columns.indexOf(column.columnData) === -1)
                                columns.push(column.columnData);
                        }
                        else {
                            if (columns.indexOf(column.columnData) !== -1)
                                columns = _.filter(columns, _.bind(function (columnTemp) {
                                    return columnTemp != column.columnData;
                                }, this));
                        }
                    }, this));

                    setting.columns = columns;
                }
            }, this));
        }, this));

        this.options.settings.save(null, {
            success: _.bind(function() {
                this.userSettings.save(null, {
                    success: _.bind(function () {
                        this.userSettings.set('defaultView', this.options.defaultView);
                        fnOnSave();
                    }, this)
                });
            }, this)
        });
    },
    countryChanged: function() {
        let country =  this.options.settings.get('customSettings').payee.country &&  this.options.settings.get('customSettings').payee.country.length > 0 ?  this.options.settings.get('customSettings').payee.country.toLowerCase() : 'us',
            options = '<option value="">Select Value</option>';
        _.each(PJQ.constants.states[country], function (state) {
            options += '<option value="' + state.abbreviation.toLowerCase() + '">' + state.name + '</option>';
        });
        this.statePicker.$el.html(options);
        this.statePicker.refresh();
        if ( this.options.settings.get('customSettings').payee.state)
            this.statePicker.setValue( this.options.settings.get('customSettings').payee.state.toLowerCase());

        PJQ.helpers.inputHelpers.inputMaskZip(this.$('.payee-zip'), country);
    },
    paymentTermsOverride: function() {
        this.$('.payment-terms').val('').prop('disabled', false);
        this.$('.payment-terms-revert').removeClass('hidden');
        this.$('.payment-terms-override').addClass('hidden');
        this.$('.payment-terms').focus();
    },
    paymentTermsRevert: function () {
        this.$('.payment-terms').val(this.options.settings.get('defaultSettings').paymentTerms).prop('disabled', true);
        this.$('.payment-terms-revert').addClass('hidden');
        this.$('.payment-terms-override').removeClass('hidden');
    },
    paymentProcessingTermsOverride: function() {
        this.$('.payment-processing-terms').val('').prop('disabled', false);
        this.$('.payment-processing-terms-revert').removeClass('hidden');
        this.$('.payment-processing-terms-override').addClass('hidden');
        this.$('.payment-processing-terms').focus();
    },
    paymentProcessingTermsRevert: function () {
        this.$('.payment-processing-terms').val(this.options.settings.get('defaultSettings').paymentProcessingTerms).prop('disabled', true);
        this.$('.payment-processing-terms-revert').addClass('hidden');
        this.$('.payment-processing-terms-override').removeClass('hidden');
    }
});

PJQ.views.invoices.ViewNotificationsModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.INVOICES, 'modal-invoice-notifications'),
        width: 700,
        minWidth: 700
    },
    beforeRender: function() {
        if (this.data == null) {
            this.data = new PJQ.collections.invoices.Notifications(null, {invoiceId: this.options.invoiceId});
            this.data.fetch({
                success: _.bind(function () {
                    this.isFetched = true;
                    this.render();
                }, this)
            });
        }
    },
    afterRender: function() {
        if (!this.isFetched)
            return;

        new PJQ.views.dataTables.DataTable({
            el: this.$('.list-data'),
            pageLength: 999999,
            isHideSearch: true,
            data: this.data.models,
            dom: 't',
            order: [],
            columns: [
                {
                    "title": "Date",
                    "width": '90px',
                    "orderable": false,
                    "render": _.bind(function (data, type, row) {
                        return PJQ.helpers.dateHelpers.getDateString(new Date(row.get('createdOn')), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME);
                    }, this)
                },
                {
                    "title": 'Type',
                    "orderable": false,
                    "render": _.bind(function (data, type, row) {
                        return PJQ.constants.invoices.notificationTypeNames[row.get('notificationTypeId')];
                    }, this)
                },
                {
                    "data": "attributes.email",
                    "orderable": false,
                    "title": "Email"
                },
                {
                    "orderable": false,
                    "title": "Status",
                    "width": "100px",
                    "render": _.bind(function (data, type, row) {
                        return '<span title="' + (_.size(row.get('broadcastErrorMessage')) === 0 ? row.get('broadcastStatus') : row.get('broadcastErrorMessage')) + '" >' + row.get('broadcastStatus') + '</span>';
                    }, this)
                }
            ]
        });
    }
});

PJQ.views.invoices.ViewTransactionsModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.INVOICES, 'modal-invoice-transactions'),
        width: 600,
        minWidth: 600
    },
    beforeRender: function() {
        if (this.data == null) {
            this.data = new PJQ.collections.invoices.Transactions(null, {invoiceId: this.options.invoiceId});
            this.data.fetch({
                success: _.bind(function () {
                    this.isFetched = true;
                    this.render();
                }, this)
            });
        }
    },
    afterRender: function() {
        if (!this.isFetched)
            return;

        new PJQ.views.dataTables.DataTable({
            el: this.$('.list-data'),
            pageLength: 999999,
            isHideSearch: true,
            data: this.data.models,
            dom: 't',
            order: [],
            columns: [
                {
                    "title": "Date",
                    "width": '90px',
                    "orderable": false,
                    "render": _.bind(function (data, type, row) {
                        return PJQ.helpers.dateHelpers.getDateString(new Date(row.get('createdOn')), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME);
                    }, this)
                },
                {
                    "title": 'Type',
                    "width": '100px',
                    "orderable": false,
                    "render": _.bind(function (data, type, row) {
                        return PJQ.constants.invoices.transactionTypeNames[row.get('transactionTypeId')];
                    }, this)
                },
                {
                    "width": '100px',
                    "title": 'Method',
                    "orderable": false,
                    "render": _.bind(function (data, type, row) {
                        return PJQ.constants.invoices.paymentTypeNames[row.get('paymentTypeId')];
                    }, this)
                },
                {
                    "data": "attributes.last4",
                    "width": '60px',
                    "orderable": false,
                    "title": "Last 4"
                },
                {
                    "title": 'Amount',
                    "width": '120px',
                    "className": "text-align-right",
                    "orderable": false,
                    "render": _.bind(function (data, type, row) {
                        return PJQ.helpers.formatHelpers.formatCurrency(row.get('amount'));
                    }, this)
                }

            ]
        });
    }
});

PJQ.views.invoices.InvoicePreview = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.INVOICES, 'invoice-preview')
    },
});